import { render, staticRenderFns } from "./rewardShopPromotionEdit.vue?vue&type=template&id=73333fd6&scoped=true&"
import script from "./rewardShopPromotionEdit.vue?vue&type=script&lang=js&"
export * from "./rewardShopPromotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73333fd6",
  null
  
)

export default component.exports